import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Trophy, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BodybuildingPrep = () => {
  useEffect(() => {
    AOS.init({ duration: 600, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <Trophy size={64} className="service-hero-icon" />
            <h1 className="display-large">Bodybuilding Prep</h1>
            <p className="body-large">
              Competition-level coaching for aspiring bodybuilders. Benefit from my experience 
              competing in elite shows like Vancity Showdown.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img src="https://images.unsplash.com/photo-1605822335686-ce034adfda7d" alt="Bodybuilding Prep" />
            </div>
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">Competition Ready</h2>
              <p className="body-medium">
                Having competed in the Vancity Showdown, I understand what it takes to step on 
                stage with confidence. I'll guide you through every aspect of competition prep, 
                from training and nutrition to posing and presentation.
              </p>
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Periodized Hypertrophy Training</h4>
                      <p className="body-small">Strategic muscle building phases for optimal stage presentation</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Peak Week Strategies</h4>
                      <p className="body-small">Expert guidance on water, sodium, and carb manipulation</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Competition Nutrition</h4>
                      <p className="body-small">Precise meal timing and macros for stage-ready conditioning</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Posing Practice</h4>
                      <p className="body-small">Learn to showcase your physique with confident stage presence</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready to Compete?</h2>
            <p className="body-large">Let's prepare you for the stage with elite-level coaching.</p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
              </Link>
              <Link to="/services"><Button className="btn-secondary">View All Services</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BodybuildingPrep;
